import React from 'react';
import { useTranslation } from 'react-i18next';
import Flex from '../../../components/Flex';
import { Form } from 'antd';
import { Button, Input, useTheme } from '@prio365/prio365-react-library';
import { colon } from '../../../util/forms';
import { PrioTheme } from '../../../theme/types';
import { JiraUserConfigurationData } from '../../../models/ProjectExtension';
import { makePrioStyles } from '../../../theme/utils';
import { Setting } from '../../../models/Settings';
import { apiDeleteSetting } from '../../settings/api';

const useStyles = makePrioStyles((theme: PrioTheme) => ({
  rootLayout: {
    margin: 0,
  },
  contentFooter: {
    marginTop: `${theme.spacing.regular}px`,
    padding: `${theme.spacing.regular}px ${theme.spacing.regular * 2}px`,
    backgroundColor: theme.colors.application.background.default,
    textAlign: 'right',
  },
  readOnlyInput: {
    border: 'none',
    boxShadow: 'none',
    '&:hover': {
      border: 'none',
      boxShadow: 'none',
    },
    '&:focus-visible': {
      border: 'none',
      boxShadow: 'none',
    },
  },
  editContent: {
    backgroundColor: theme.colors.application.background.default,
  },
  form: {
    height: '100%',
    width: '100%',
    overflow: 'auto',
  },
  fullWidth: {
    width: '100%',
  },
  header: {
    marginLeft: '30px',
    marginBlock: theme.spacing.regular,
  },
}));

interface AddInItemConfigProps {
  className?: string;
  projectExtensionUserConfigurationChanged?: () => void;
  jiraSetting: Setting;
  onClose: VoidFunction;
}

export const JiraUserConfigurationForm: React.FC<AddInItemConfigProps> = (
  props
) => {
  //#region ------------------------------ Defaults
  const { projectExtensionUserConfigurationChanged, onClose, jiraSetting } =
    props;
  const { t } = useTranslation();
  const theme = useTheme<PrioTheme>();
  const classes = useStyles();
  const [dataForm] = Form.useForm<JiraUserConfigurationData>();
  //#endregion

  //#region ------------------------------ States / Attributes / Selectors
  //#endregion

  //#region ------------------------------ Methods / Handlers
  const handleFinish = () => {
    onClose();
  };

  const handleDelete = async () => {
    await apiDeleteSetting(jiraSetting[0]?.settingId);
    projectExtensionUserConfigurationChanged();
    onClose();
  };
  //#endregion

  //#region ------------------------------ Effects
  //#endregion

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
      }}
    >
      <div style={{ display: 'flex', flex: 1, width: '100%' }}>
        <Form
          layout="vertical"
          form={dataForm}
          className={classes.form}
          onFinish={handleFinish}
        >
          <Flex.Row flex={1}>
            <Flex.Column flex={2} childrenGap={theme.spacing.small}>
              <Flex.Row flex={1} alignItems="center">
                <h4>{t('projects:addIn.jiraConfig.connection')}</h4>
              </Flex.Row>
              <Flex.Row
                childrenGap={theme.spacing.small}
                flex={1}
                justifyContent="stretch"
              >
                <Form.Item
                  name={['objectJson', 'userCredentials', 'mail']}
                  label={t('projects:addIn.jiraConfig.mail')}
                  colon={colon}
                  style={{ flex: 1 }}
                >
                  <Input disabled={true} full defaultValue={'*******'} />
                </Form.Item>
                <Form.Item
                  name={['objectJson', 'userCredentials', 'apiKey']}
                  label={t('projects:addIn.jiraConfig.apiToken')}
                  colon={colon}
                  style={{ flex: 1 }}
                >
                  <Input
                    disabled={true}
                    type="password"
                    full
                    defaultValue={'*******'}
                  />
                </Form.Item>
              </Flex.Row>
              <Flex.Row
                childrenGap={theme.spacing.small}
                flex={1}
                justifyContent="flex-end"
              ></Flex.Row>
            </Flex.Column>
          </Flex.Row>
        </Form>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button type="danger" onClick={handleDelete}>
          {t('projects:addIn.jiraConfig.delete')}
        </Button>
      </div>
    </div>
  );
};

export default JiraUserConfigurationForm;
